import { twMerge } from '@/lib/classname/twMerge'
import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'

const loaderCva = cva(
  'block animate-spin rounded-full border-2 border-current border-t-[transparent]',
  {
    variants: {
      size: {
        sm: 'size-1',
        md: 'size-2',
        '2xl': 'size-5',
      },
    },
    defaultVariants: {
      size: 'md',
    },
  },
)

export type LoaderProps = UiComponentProps<VariantProps<typeof loaderCva>>

// aria-label is unused: the span is always aria-hidden, so it's never exposed
export function Loader({ className, size, id, 'data-testid': dataTestId = 'loader' }: LoaderProps) {
  return (
    <span
      id={id}
      className={twMerge(className, loaderCva({ size }))}
      data-testid={dataTestId}
      aria-hidden
    />
  )
}
